const PageOverlay = () => {

document.addEventListener("DOMContentLoaded", function() {
    const overlay = document.querySelector('.page-overlay');
    const parentItems = document.querySelectorAll('.header__item--parent');
  
    parentItems.forEach(item => {
      item.addEventListener('mouseenter', function() {
        overlay.classList.add('page-overlay--active');
      });
      item.addEventListener('mouseleave', function() {
        overlay.classList.remove('page-overlay--active');
      });
    });
  });

}

export default PageOverlay;